import { z } from 'zod';
// Phone format is user's concern
const phonePattern = /^(?!\s*$).+/;

export const phone = z
  .string()
  .regex(
    phonePattern,
    'Nesprávný format telefonního čísla. Příklad správného: 123 456 789'
  );
